import { Button } from "flowbite-react";
import React from 'react';
import { Link } from "react-router-dom";

export function BudgetContent() {
  return (
    <div className='p-3'>
      <h3 className='font-bold pb-3'>Budget</h3>
      <p>
        Detailed content about Budget. This section explains how to estimate costs for various aspects of production, including pre-production, filming, and post-production. It involves creating a detailed budget plan that outlines expenses such as equipment rentals, location fees, talent fees, and production staff costs. The budget helps in financial planning and ensures that resources are allocated efficiently. Additionally, it includes tracking and managing expenses throughout the production process to stay within budgetary constraints.
      </p>
      <a href='#' className='text-blue-600 underline'>Learn more</a>
      <Link to='/budget'><Button color='dark' className="mt-2">Skip</Button></Link>
    </div>
  );
}
